export interface NoteUpdatesEvent {
  readonly changedIds: readonly number[];
  readonly revision: number;
}

export interface NoteUpdatesController {
  publish(changedIds: readonly number[]): void;
  subscribe(listener: (event: NoteUpdatesEvent) => void): () => void;
}

export function normalizeNoteIds(ids: readonly number[]): number[] {
  return [...new Set(ids.filter(id => Number.isSafeInteger(id) && id > 0))];
}

export function createNoteUpdatesController(): NoteUpdatesController {
  const listeners = new Set<(event: NoteUpdatesEvent) => void>();
  let revision = 0;

  return {
    publish(ids) {
      const changedIds = normalizeNoteIds(ids);
      if (changedIds.length === 0) return;
      const event: NoteUpdatesEvent = { changedIds, revision: ++revision };
      for (const listener of [...listeners]) listener(event);
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => { listeners.delete(listener); };
    },
  };
}
